import moment from 'moment'

export default durations => moment.duration(durations * 1000).humanize()
